<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="InstitutionArg">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            机构参数配置
        </div>
        <div style="padding: 20px;"> 

            <div>

                <el-row>
                    <el-button type="primary" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit"  @click="toggleModalEdit">编辑</el-button>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table
                    :data="tableData"
                    border
                    :height="th"
                    v-loading="loading"
                    highlight-current-row 
                    @row-click='rowClick'
                    style="width: 100%">
                    <el-table-column
                        prop="institution.name"
                        label="机构名称"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="chargeTime"
                        label="自动扣费规则"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.chargeTime=='day'">天</span>
                            <span v-if="scope.row.chargeTime=='month'">月</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="autoCharge"
                        label="是否自动扣费"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.autoCharge=='0'">否</span>
                            <span v-if="scope.row.autoCharge=='1'">是</span>
                        </template>
                    </el-table-column>
                    </el-table>
                </template>
            </div>
        </div>
        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Add from "./Add";
    import Edit from "./Edit";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                menuButtonList:null,
                th:0,
                row:null,
                showModalAdd:false,
                showModalInfo:false,
                showModalEdit:false,
                disabledEdit:true,
                tableData:null,
            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
             
            toggleModalAdd:function(){
                this.$refs.myAdd.init();
                this.showModalAdd = !this.showModalAdd;
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"InstitutionArg/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    this.loading = false;
                    this.disabledEdit=true;
                    if(response.data.error == 0){
                        console.log(response.data);
                        this.tableData = response.data.data;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            toggleModalEdit(){
                this.showModalEdit = !this.showModalEdit;
                this.$refs.myEdit.init(this.row);
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            rowClick(row){
                 this.row = row;
                this.disabledEdit =false;
            }



        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }
</style>
